import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentControlWrapper = _ref => {
  let {
      children,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({
    className: classNames('content-control-wrapper', className)
  }, rest, {
    children: children
  }));
};
export default ContentControlWrapper;